/* THE CINDER (LS-293): a beetle the size of a fist, its shell dark and split down the back, four embers glowing
 * through it that pulse as it walks -- and glow brighter the more it has eaten. Eight frames: the legs step on
 * a four-beat, the embers swap between red and gold every other frame. It lives where the ground is hot, it
 * fears no fire, it walks into one and eats it, and each fire eaten is a life more on its shell.
 * Generated once from a small script and kept as data like every other actor. */

export const cinder_0 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '......oyyo......',
  '.....oooooo.....',
  '..ooodddoddooo..',
  '...odyddoddro...',
  '.oooddddodddooo.',
  '...oddydodrdo...',
  '...oddddodddo...',
  '..ooodddoddooo..',
  '.....oooooo.....',
  '................',
  '................',
  '................',
];

export const cinder_1 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '......oyyo......',
  '.....oooooo.....',
  '....odddoddo....',
  'oooodyddoddroooo',
  '...oddddodddo...',
  '...oddydodrdo...',
  '...oddddodddo...',
  '....odddoddo....',
  '.ooo.oooooo.ooo.',
  '................',
  '................',
  '................',
];

export const cinder_2 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '......oyyo......',
  '.....oooooo.....',
  '.oo.odddoddo.oo.',
  '...odrddoddyo...',
  '..ooddddodddoo..',
  '...oddrdodydo...',
  '...oddddodddo...',
  '....odddoddo....',
  '.....oooooo.....',
  '..oo........oo..',
  '................',
  '................',
];

export const cinder_3 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '......oyyo......',
  '.....oooooo.....',
  '....odddoddo....',
  'oooodrddoddyoooo',
  '...oddddodddo...',
  '...oddrdodydo...',
  '...oddddodddo...',
  '....odddoddo....',
  '.ooo.oooooo.ooo.',
  '................',
  '................',
  '................',
];

export const cinder_4 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '......oyyo......',
  '.....oooooo.....',
  '..ooodddoddooo..',
  '...odrddoddyo...',
  '.oooddddodddooo.',
  '...oddrdodydo...',
  '...oddddodddo...',
  '..ooodddoddooo..',
  '.....oooooo.....',
  '................',
  '................',
  '................',
];

export const cinder_5 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '......oyyo......',
  '.ooo.oooooo.ooo.',
  '....odddoddo....',
  '...odyddoddro...',
  '...oddddodddo...',
  'ooooddydodrdoooo',
  '.oooddddodddooo.',
  '....odddoddo....',
  '.....oooooo.....',
  '................',
  '................',
  '................',
];

export const cinder_6 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '..oo..oyyo..oo..',
  '.....oooooo.....',
  '....odddoddo....',
  '...odyddoddro...',
  '...oddddodddo...',
  '..ooddydodrdoo..',
  '.oooddddodddooo.',
  '....odddoddo....',
  '.....oooooo.....',
  '................',
  '................',
  '................',
];

export const cinder_7 = [
  '................',
  '................',
  '......o..o......',
  '.......oo.......',
  '......oyyo......',
  '.ooo.oooooo.ooo.',
  '....odddoddo....',
  '...odrddoddyo...',
  '...oddddodddo...',
  'ooooddrdodydoooo',
  '.oooddddodddooo.',
  '....odddoddo....',
  '.....oooooo.....',
  '................',
  '................',
  '................',
];
